// PrivateCMILayout.js
import { Outlet, useLocation } from "react-router-dom";
import { Navigate, } from 'react-router-dom';
import { useAuthCuadroMando } from "./../context/AuthCuadroMandoContext"

import Dashboard from "../../../pages/Dashboard";
import WelcomeSplash from "../../../component/WelcomeSplash/WelcomeSplash";

export function PrivateCMILayout(props) {
    const { isAuthenticated, loading, logOut } = useAuthCuadroMando();
    
    const location = useLocation();

    if (isAuthenticated === null || loading) {
        return <WelcomeSplash isLoading={loading} />;
    }

    if (isAuthenticated === false) {
        return <Navigate to="/inicio-sesion" replace state={{ from: location.pathname }} />;
    }

    return (
        <Dashboard  {...props} LogOut={logOut} Loading={loading} ><Outlet /></Dashboard>
    );
}